import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import appstore1 from "assets/img/googleApp.png";
import appstore2 from "assets/img/appleApp.png";
import jerrysplash from "assets/images/Mask Group11_new3.png";
import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";
import { Person, CalendarToday, CreditCard } from "@material-ui/icons";
import { FormattedMessage, injectIntl } from "react-intl";
import { APP_NAME } from "../../utils/config/constants";

class AppLinks extends React.Component {
    checkIcon() {
        return (
            <svg
                fill="#0078ff"
                className="icon_check"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 50 50"
                width="22px"
                height="22px"
            >
                <path d="M 41.9375 8.625 C 41.273438 8.648438 40.664063 9 40.3125 9.5625 L 21.5 38.34375 L 9.3125 27.8125 C 8.789063 27.269531 8.003906 27.066406 7.28125 27.292969 C 6.5625 27.515625 6.027344 28.125 5.902344 28.867188 C 5.777344 29.613281 6.078125 30.363281 6.6875 30.8125 L 20.625 42.875 C 21.0625 43.246094 21.640625 43.410156 22.207031 43.328125 C 22.777344 43.242188 23.28125 42.917969 23.59375 42.4375 L 43.6875 11.75 C 44.117188 11.121094 44.152344 10.308594 43.78125 9.644531 C 43.410156 8.984375 42.695313 8.589844 41.9375 8.625 Z" />
            </svg>
        );
    }

    render() {
        const { classes, settings } = this.props;
        const { formatMessage } = this.props.intl;
        return (
            <section className="app_links">
                <div className="side_img2">
                    <img
                        src={require("../../assets/images/rectangle6.png")}
                        alt={"img"}
                    />
                </div>
                <div className="container" >
                    <h2 className="web-app-con-text" style={{
                        textAlign: 'center',
                    }}>
                        Download Our
                        App to Book a Job Today
                    </h2>

                    <div className="row d-flex justify-content-center" >
                        <div className="col-sm-12 col-md-6 text-center">
                            <div className="web-app-img">
                                {" "}
                                <img src={jerrysplash} alt={APP_NAME} />{" "}
                                <img
                                    style={{
                                        verticalAlign: "middle",
                                        borderStyle: "none",
                                        left: 0,
                                        objectFit: "contain",
                                        position: "absolute",
                                        alignSelf: "center",
                                    }}
                                    src={require("../../assets/images/group5.png")}
                                    alt={"img"}
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6" style={{ paddingTop: 50 }}>
                            <div className="web-app-con">
                                <ul>
                                    <li style={{ color: "#A3A7AE" }}>
                                        {this.checkIcon()}{" "}
                                        <span>
                                            Directly book service pros in your
                                            area{" "}
                                        </span>
                                    </li>
                                    <li style={{ color: "#A3A7AE" }}>
                                        {this.checkIcon()}{" "}
                                        <span>Same Day or Future Booking</span>
                                    </li>
                                    <li style={{ color: "#A3A7AE" }}>
                                        {this.checkIcon()}{" "}
                                        <span>
                                            All Pros Screened and background
                                            checked
                                        </span>
                                    </li>
                                    <li style={{ color: "#A3A7AE" }}>
                                        {this.checkIcon()}{" "}
                                        <span>
                                            Manage Your home Repairs in our app
                                        </span>
                                    </li>
                                </ul>{" "}
                                <ul className="d-flex download-app-ul">
                                    {this.props.settings.constants
                                        .androidCustomerAppLink &&
                                        this.props.settings.constants
                                            .androidCustomerAppLink != "" && (
                                            <li>
                                                <a
                                                    target="_blank"
                                                // href={
                                                //     this.props.settings
                                                //         .constants
                                                //         .androidCustomerAppLink
                                                // }
                                                >
                                                    <img
                                                        src={appstore1}
                                                        alt={APP_NAME}
                                                    />
                                                </a>
                                            </li>
                                        )}
                                    {this.props.settings.constants
                                        .iosCustomerAppLink &&
                                        this.props.settings.constants
                                            .iosCustomerAppLink != "" && (
                                            <li>
                                                <a
                                                    target="_blank"
                                                // href={
                                                //     this.props.settings
                                                //         .constants
                                                //         .iosCustomerAppLink
                                                // }
                                                >
                                                    <img
                                                        src={appstore2}
                                                        alt={APP_NAME}
                                                    />
                                                </a>
                                            </li>
                                        )}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default withStyles(productStyle)(injectIntl(AppLinks));



// WEBPACK FOOTER //
// ./src/components/About/AppLinks.js